import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Checkbox,
  Button,
  MenuItem,
  IconButton,
  Box,
  CircularProgress,
  Chip,
  FormControl,
  FormControlLabel,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import "./addroute.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const AddRoutingProfilePage = ({
  onClose,
  onProfileAdded,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // ✅ Channels
  const [selectAll, setSelectAll] = useState(false);
  const [enabledRows, setEnabledRows] = useState({
    voice: true,
    chat: false,
    task: false,
  });
  const [contacts, setContacts] = useState({ voice: 1, chat: 1, task: 1 });
  const [concurrency, setConcurrency] = useState({});

  const instanceAlias = localStorage.getItem("instanceName");
  const email = localStorage.getItem("Email");
  const username = localStorage.getItem("username");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
  const region = localStorage.getItem("Region");

  const [queues, setQueues] = useState([]);
  const [queueList, setQueueList] = useState([]);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [defaultname, setdefaultname] = useState("");

  // ✅ Routing Order
  const [routingOrderChecked, setRoutingOrderChecked] = useState(false);

  // ✅ Tags
  const [showTags, setShowTags] = useState(false);
  const [tags, setTags] = useState([]);
  const [keyTag, setKeyTag] = useState("");
  const [valueTag, setValueTag] = useState("");

  // ✅ Loader States
  const [loading, setLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
const [actionClicked, setActionClicked] = useState(null); 
  const [agentAvailabilityTimer, setAgentAvailabilityTimer] = useState(
    "TIME_SINCE_LAST_ACTIVITY"
  );

  const handleQueueList = async () => {
    const payload = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
      InstanceAlias: instanceAlias,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displayOutboundQueues.displayQueues,
        payload,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      console.log("✅ Response:", response.data);

      const body = response.data?.body ? JSON.parse(response.data.body) : [];
      setQueueList(Array.isArray(body) ? body : [body]);

    } catch (error) {
      console.error("🔥 Error retrieving queue data:", error?.response?.data || error.message, error);
    }
  };

  useEffect(() => {
    handleQueueList();
  }, []);

  const handleCheckboxChange = (event) => {
    setAgentAvailabilityTimer(
      event.target.checked
        ? "TIME_SINCE_LAST_INBOUND"
        : "TIME_SINCE_LAST_ACTIVITY"
    );
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    setTouched(prev => ({ ...prev, name: true }));
    
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, name: "Name is required" }));
    } else {
      setErrors((prev) => ({ ...prev, name: null }));
    }
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setDescription(value);
    setTouched(prev => ({ ...prev, description: true }));
    
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, description: "Description is required" }));
    } else {
      setErrors((prev) => ({ ...prev, description: null }));
    }
  };

  const handleDefaultQueueChange = (e) => {
    const value = e.target.value;
    setdefaultname(value);
    setTouched(prev => ({ ...prev, defaultname: true }));
    
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, defaultname: "Please select an outbound queue" }));
    } else {
      setErrors((prev) => ({ ...prev, defaultname: null }));
    }
  };

  const validateName = (value) => {
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, name: "Name is required" }));
      return false;
    }
    setErrors((prev) => ({ ...prev, name: null }));
    return true;
  };

  const validateDescription = (value) => {
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, description: "Description is required" }));
      return false;
    }
    setErrors((prev) => ({ ...prev, description: null }));
    return true;
  };

  const validateDefaultQueue = (value) => {
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, defaultname: "Please select an outbound queue" }));
      return false;
    }
    setErrors((prev) => ({ ...prev, defaultname: null }));
    return true;
  };

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    setEnabledRows({
      voice: checked,
      chat: checked,
      task: checked,
    });
  };

  const handleTableCheckboxChange = (row) => {
    setEnabledRows((prev) => {
      const newEnabledRows = {
        ...prev,
        [row]: !prev[row],
      };
      
      // Clear channel errors when at least one channel is selected
      const hasEnabledChannel = Object.values(newEnabledRows).some(isEnabled => isEnabled);
      if (hasEnabledChannel) {
        setErrors(prevErrors => ({ ...prevErrors, channel: null }));
      }
      
      return newEnabledRows;
    });
  };

  const handleContactChange = (e, row) => {
    const value = Math.max(1, Math.min(10, Number(e.target.value)));
    setContacts((prev) => ({
      ...prev,
      [row]: value,
    }));
    
    // Clear contact error for this row
    setErrors(prev => ({ ...prev, [row]: null }));
  };

  const handleConcurrencyChange = (e, row) => {
    const value = e.target.value;
    setConcurrency((prev) => ({
      ...prev,
      [row]: value,
    }));
    
    // Clear concurrency error for this row
    setErrors(prev => ({ ...prev, [`concurrency-${row}`]: null }));
  };

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    // Name validation
    if (!name.trim()) {
      tempErrors.name = "Name is required.";
      isValid = false;
    }

    // Description validation
    if (!description.trim()) {
      tempErrors.description = "Description is required.";
      isValid = false;
    }

    // At least one channel must be enabled
    if (!Object.values(enabledRows).some((isEnabled) => isEnabled)) {
      tempErrors.channel = "At least one channel must be selected.";
      isValid = false;
    }

    // Default outbound queue validation
    if (!defaultname.trim()) {
      tempErrors.defaultname = "Please select an outbound queue.";
      isValid = false;
    }

    // Maximum contacts per agent validation for enabled channels
    ["voice", "chat", "task"].forEach((channel) => {
      if (enabledRows[channel]) {
        const contactValue = contacts[channel];
        if (!contactValue || contactValue < 1 || contactValue > 10) {
          tempErrors[channel] = "Value must be between 1 and 10.";
          isValid = false;
        }
        
        // Cross-channel concurrency validation
        if (!concurrency[channel]) {
          tempErrors[`concurrency-${channel}`] = "Please select an option for cross-channel concurrency.";
          isValid = false;
        }
      }
    });

    // Queue validation
    const channelSets = {};
    queues.forEach((queue, index) => {
      // Validate queue name
      if (!queue.name || queue.name.trim() === "") {
        tempErrors[`name-${index}`] = "Please select a queue.";
        isValid = false;
      }

      // Check if any channels are selected
      if (queue.channels.length === 0) {
        tempErrors[`channels-${index}`] = "Please select at least one channel.";
        isValid = false;
      } else {
        // Create a unique key for this queue's name and channels
        const key = `${queue.name}-${queue.channels.join(",")}`;

        // If channels are already used for a different queue, set an error
        if (channelSets[key]) {
          tempErrors[`channels-${index}`] = "Queue and channel type combination cannot be duplicated";
          isValid = false;
        } else {
          channelSets[key] = true;
        }
      }

      // Priority validation
      if (queue.priority === null || queue.priority === "" || queue.priority < 1 || queue.priority > 99) {
        tempErrors[`priority-${index}`] = "Priority must be between 1 and 99.";
        isValid = false;
      }

      // Delay validation
      if (queue.delay === null || queue.delay === "" || queue.delay < 0 || queue.delay > 9999) {
        tempErrors[`delay-${index}`] = "Delay must be between 0 and 9999.";
        isValid = false;
      }
    });

    setErrors(tempErrors);
    return isValid;
  };

  const handleAddQueue = () => {
    setQueues((prev) => [
      ...prev,
      {
        id: Date.now(),
        checked: false,
        name: "",
        channels: [],
        priority: "",
        delay: "",
      },
    ]);
  };

  const handleDeleteQueue = () => {
    const updated = queues.filter((queue) => !queue.checked);
    setQueues(updated);
    setDeleteDisabled(true);
    
    // Clear errors for deleted queues
    const remainingIndexes = updated.map((_, index) => index);
    const newErrors = { ...errors };
    Object.keys(newErrors).forEach(key => {
      if (key.includes('-') && !remainingIndexes.includes(parseInt(key.split('-')[1]))) {
        delete newErrors[key];
      }
    });
    setErrors(newErrors);
  };

  const handleQueueChange = (index, field, value) => {
    const updated = [...queues];
    if (field === "channels") {
      const exists = updated[index].channels.includes(value);
      updated[index].channels = exists
        ? updated[index].channels.filter((ch) => ch !== value)
        : [...updated[index].channels, value];
        
      // Clear channel error for this queue
      setErrors(prev => ({ ...prev, [`channels-${index}`]: null }));
    } else {
      updated[index][field] = value;
      
      // Clear specific field error
      if (field === "name") {
        setErrors(prev => ({ ...prev, [`name-${index}`]: null }));
      } else if (field === "priority") {
        setErrors(prev => ({ ...prev, [`priority-${index}`]: null }));
      } else if (field === "delay") {
        setErrors(prev => ({ ...prev, [`delay-${index}`]: null }));
      }
    }
    
    updated[index].checked = updated[index].checked || false;
    setQueues(updated);
    setDeleteDisabled(!updated.some((q) => q.checked));
  };

  const toggleShowTags = () => setShowTags((prev) => !prev);

  const handleKeyChange = (e) => setKeyTag(e.target.value);
  const handleValueChange = (e) => setValueTag(e.target.value);

  const handleAddTag = () => {
    if (keyTag && valueTag) {
      setTags((prev) => [...prev, { key: keyTag, value: valueTag }]);
      setKeyTag("");
      setValueTag("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setTags((prev) => prev.filter((tag) => tag !== tagToDelete));
  };

  const handleCancel = () => {
    setActionClicked("cancel");
    setCancelLoading(true);
    setTimeout(() => {
      setCancelLoading(false);
      setActionClicked(null);
      onClose();
    }, 500);
  };

  const fetchRoutingProfile = async () => {
    const payload = {
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displayroutes.viewroutes,
        payload
      );

      if (response.data && Array.isArray(response.data)) {
        const extractedData = response.data.map((item) => {
          const associatedQueues = item.AssociatedQueues?.map((queue) => {
            return `${queue.QueueName} (Priority: ${queue.Priority}, Delay: ${queue.Delay}, Channel: ${queue.Channel})`;
          }).join(" | ") || "No Associated Queues";

          const mediaConcurrencies = item.MediaConcurrencies?.map((media) => {
            return `${media.Channel} (Concurrency: ${media.Concurrency}, Behavior: ${media.CrossChannelBehavior?.BehaviorType || "-"})`;
          }).join(" | ") || "No Media Channels";

          let tags = "No tags";
          if (item.Tags) {
            let tagObj = null;

            if (typeof item.Tags === "object" && !Array.isArray(item.Tags)) {
              tagObj = item.Tags;
            } else if (typeof item.Tags === "string") {
              try {
                const parsed = JSON.parse(item.Tags);
                if (typeof parsed === "object" && !Array.isArray(parsed)) {
                  tagObj = parsed;
                }
              } catch (e) {
                console.warn("Failed to parse Tags string:", item.Tags);
              }
            }

            if (tagObj) {
              tags = Object.entries(tagObj)
                .map(([key, value]) => `${key}:${value}`)
                .join(", ");
            }
          }

          return {
            name: item.Name,
            description: item.Description || "No description",
            tags: item.Tags,
            agentAvailabilityTimer: item.AgentAvailabilityTimer || "-",
            defaultOutboundQueueName: item.DefaultOutboundQueueName || "-",
            numberOfAssociatedQueues: item.NumberOfAssociatedQueues || 0,
            numberOfAssociatedUsers: item.NumberOfAssociatedUsers || 0,
            associatedQueues,
            mediaConcurrencies,
          };
        });

        return extractedData;
      } else {
        console.warn("Unexpected response format", response.data);
        return [];
      }
    } catch (error) {
      console.error("❌ Error fetching routing profiles:", error);
      return [];
    }
  };

  const handleSave = async () => {
    console.log("🔍 Starting validation...");
    
    // Mark all fields as touched
    setTouched({
      name: true,
      description: true,
      defaultname: true,
    });
    
    if (!validateFields()) {
      console.log("❌ Validation failed", errors);
      return;
    }

    console.log("✅ Validation passed, starting save...");
    setActionClicked("save");
    setLoading(true);

    try {
      // ✅ Convert tags array into dictionary
      const tagsDictionary = tags.reduce((acc, t) => {
        acc[t.key] = t.value;
        return acc;
      }, {});

      // ✅ Build media concurrency structure
      const mediaConcurrencies = [];
      
      if (enabledRows.voice) {
        mediaConcurrencies.push({
          Channel: "VOICE",
          Concurrency: 1,
          CrossChannelBehavior: { BehaviorType: concurrency.voice },
        });
      }
      
      if (enabledRows.chat) {
        mediaConcurrencies.push({
          Channel: "CHAT",
          Concurrency: contacts.chat || 1,
          CrossChannelBehavior: { BehaviorType: concurrency.chat },
        });
      }
      
      if (enabledRows.task) {
        mediaConcurrencies.push({
          Channel: "TASK",
          Concurrency: contacts.task || 1,
          CrossChannelBehavior: { BehaviorType: concurrency.task },
        });
      }

      const requestPayload = {
        action: "create",
        region,
        ID: EncryptedInstanceId,
        awsAccount: customerAWSAccountId,
        InstanceAlias: instanceAlias,
        outbound_queue_name: defaultname,
        Email: email,
        UserName: username,
        name,
        Tags: tagsDictionary,
        description,
        queueConfigs: queues.flatMap((queue) =>
          queue.channels.map((channel) => ({
            QueueReference: { QueueName: queue.name || "", Channel: channel },
            Priority: Number(queue.priority) || 0,
            Delay: Number(queue.delay) || 0,
          }))
        ),
        mediaConcurrencies: mediaConcurrencies,
        AgentAvailabilityTimer: agentAvailabilityTimer,
      };

      console.log("📤 Request payload:", requestPayload);

      const response = await axiosInstance.post(
        endpoints.addRoute.newRoute,
        requestPayload
      );

      console.log("✅ Routing profile created:", response.data);

      if (response.data) {
        const updatedList = await fetchRoutingProfile();
        if (updatedList && Array.isArray(updatedList)) {
          onProfileAdded(updatedList);
        }
        onClose();
      }
    } catch (error) {
      console.error("❌ Error creating routing profile:", error);
      alert("Failed to create routing profile. Please try again.");
    } finally {
      setLoading(false);
      setActionClicked(null);
    }
  };

  return (

        <Container className="addhour-content-container">
        <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
       {/* Back Arrow in a circular button */}
       <IconButton
         onClick={onClose}
         size="medium"
         sx={{
           border: "1px solid #ccc",       // border color
           borderRadius: "50%",            // makes it circular
           padding: 1,                     // inner spacing
           bgcolor: "#f5f5f5",             // background color
           "&:hover": { bgcolor: "#e0e0e0" } // hover effect
         }}
       >
         <ArrowBackIcon />
       </IconButton>
     
       {/* Title */}
       <Typography variant="h4" className="phone-text">
         Add Routing Profile
       </Typography>
     </Box>

      {/* Show general validation errors */}
      {(errors.channel || (Object.keys(errors).length > 0 && (touched.name || touched.description || touched.defaultname))) && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Please correct the errors below before saving.
        </Alert>
      )}

      <div className="addroute-form-section">
        <h3>Routing profile details</h3>
        <div className="addroute-form-fields">
          <TextField
            label="Name"
            placeholder="Enter Name"
            required
            value={name}
            onChange={handleNameChange}
            onBlur={() => validateName(name)}
            helperText={errors.name}
            error={!!errors.name}
            fullWidth
          />
          <TextField
            label="Description"
            placeholder="Enter description"
            required
            value={description}
            onChange={handleDescriptionChange}
            onBlur={() => validateDescription(description)}
            helperText={errors.description}
            error={!!errors.description}
            fullWidth
            inputProps={{ maxLength: 200 }}
          />
        </div>
      </div>

      {/* ✅ Channel Settings */}
      <div className="settings-form-container">
        <h3>Settings</h3>
        <Typography className="addroute-channelheading">
          Channel settings
        </Typography>
        <Typography className="additional-text">
          Define the channels that can be routed to this group of agents...
        </Typography>
        
        {errors.channel && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errors.channel}
          </Alert>
        )}

        <table className="custom-table">
          <thead>
            <tr>
              <th>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                  className="table1-check"
                />
              </th>
              <th className="table1names">Channel availability</th>
              <th className="table1names">Max contacts per agent</th>
              <th className="table1names">Cross-channel concurrency</th>
            </tr>
          </thead>
          <tbody>
            {["voice", "chat", "task"].map((row) => (
              <tr key={row}>
                <td>
                  <Checkbox
                    checked={enabledRows[row]}
                    onChange={() => handleTableCheckboxChange(row)}
                  />
                </td>
                <td>{row.toUpperCase()}</td>
                <td>
                  <TextField
                    label={
                      row === "voice"
                        ? ""
                        : row === "chat"
                        ? "Max chats per agent"
                        : "Max tasks per agent"
                    }
                    type="number"
                    value={row === "voice" ? 1 : contacts[row] || ""}
                    disabled={!enabledRows[row] || row === "voice"}
                    onChange={(e) => handleContactChange(e, row)}
                    helperText={errors[row]}
                    error={!!errors[row]}
                    inputProps={{ min: 1, max: 10 }}
                  />
                </td>
                <td>
                  <TextField
                    label="Select an option"
                    select
                    disabled={!enabledRows[row]}
                    value={concurrency[row] || ""}
                    onChange={(e) => handleConcurrencyChange(e, row)}
                    helperText={errors[`concurrency-${row}`]}
                    error={!!errors[`concurrency-${row}`]}
                    fullWidth
                  >
                    <MenuItem value="ROUTE_CURRENT_CHANNEL_ONLY">
                      No other channels while agent is on this channel
                    </MenuItem>
                    <MenuItem value="ROUTE_ANY_CHANNEL">
                      Allow other channels concurrently
                    </MenuItem>
                  </TextField>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="queues-form-container">
        <h3>Queues</h3>
        
        <div className="queue-buttons">
          <Button variant="outlined" onClick={handleAddQueue}>
            Add Queue
          </Button>
          <Button
            variant="outlined"
            onClick={handleDeleteQueue}
            disabled={deleteDisabled}
          >
            Delete Queue
          </Button>
        </div>
        <div className="table-container">
          <table className="queue-table">
            <thead>
              <tr>
                <th>
                  <Checkbox disabled />
                </th>
                <th>Name</th>
                <th>Channels</th>
                <th>Priority</th>
                <th>Delay (sec)</th>
              </tr>
            </thead>
            <tbody>
              {queues.map((queue, index) => (
                <tr key={queue.id}>
                  <td>
                    <Checkbox
                      checked={queue.checked || false}
                      onChange={() =>
                        handleQueueChange(index, "checked", !queue.checked)
                      }
                    />
                  </td>
                  <td>
                    <TextField
                      select
                      label="Search for queue"
                      value={queue.name}
                      onChange={(e) =>
                        handleQueueChange(index, "name", e.target.value)
                      }
                      helperText={errors[`name-${index}`]}
                      error={!!errors[`name-${index}`]}
                      fullWidth
                    >
                      {queueList.map((q, idx) => (
                        <MenuItem key={idx} value={q}>
                          {q}
                        </MenuItem>
                      ))}
                    </TextField>
                  </td>
                  <td>
                    <Box>
                      {["VOICE", "CHAT", "TASK"].map((channel) => (
                        <FormControlLabel
                          key={channel}
                          control={
                            <Checkbox
                              checked={queue.channels.includes(channel)}
                              onChange={() =>
                                handleQueueChange(index, "channels", channel)
                              }
                            />
                          }
                          label={channel}
                        />
                      ))}
                      {errors[`channels-${index}`] && (
                        <Typography variant="caption" color="error" display="block">
                          {errors[`channels-${index}`]}
                        </Typography>
                      )}
                    </Box>
                  </td>
                  <td>
                    <TextField
                      label="Priority"
                      type="number"
                      value={queue.priority}
                      onChange={(e) =>
                        handleQueueChange(index, "priority", e.target.value)
                      }
                      helperText={errors[`priority-${index}`]}
                      error={!!errors[`priority-${index}`]}
                      inputProps={{ min: 1, max: 99 }}
                    />
                  </td>
                  <td>
                    <TextField
                      label="Delay"
                      type="number"
                      value={queue.delay}
                      onChange={(e) =>
                        handleQueueChange(index, "delay", e.target.value)
                      }
                      helperText={errors[`delay-${index}`]}
                      error={!!errors[`delay-${index}`]}
                      inputProps={{ min: 0, max: 9999 }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
<br></br>
    <Typography  sx={{ textAlign: "left", marginLeft: 1 }}>Default outbound queue</Typography>

<TextField
  select
  fullWidth
  placeholder="Select a queue"
  value={defaultname}
  onChange={handleDefaultQueueChange}
  onBlur={() => validateDefaultQueue(defaultname)}
  helperText={errors.defaultname}
  error={!!errors.defaultname}
  margin="dense"
  sx={{ marginLeft: -50 }}   // ✅ aligns flush with heading
>
  {queueList.map((q, idx) => (
    <MenuItem key={idx} value={q}>
      {q}
    </MenuItem>
  ))}
</TextField>

      <Typography className="setroutetext">Set routing order</Typography>
      <Typography sx={{ textAlign: "left", marginLeft: 3 }}>
  By default Amazon Connect routes new inbound contacts to agents that have been in Available status the longest.
</Typography>
<br></br>
      <div className="checkbox-label">
<div style={{ display: "flex", alignItems: "center" }}>
  <Checkbox onChange={handleCheckboxChange}  className="checkstylingaddqueue" />
  <Typography>Outbound calls should not impact routing order</Typography>
</div>

</div>


       <Box className="addprompt-boxstyling" onClick={toggleShowTags}>
        <Typography className="setadvancetext">Show advanced settings
          <IconButton>
            {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        </Typography>
      </Box>
      {showTags && (
        <Box>
          <Typography>Tags (Optional)</Typography>
          <Box display="flex" gap={1} mt={2}>
            <TextField
              label="Key"
              placeholder="Key"
              value={keyTag}
              onChange={handleKeyChange}
            />
            <TextField
              label="Value"
              placeholder="value"
              value={valueTag}
              onChange={handleValueChange}
            />
            <Button
              variant="outlined"
              onClick={handleAddTag}
              disabled={!keyTag || !valueTag}
            >
              Add
            </Button>
          </Box>
          {tags.length > 0 && (
            <Box mt={2}>
              <Typography>Selected tags</Typography>
              <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                {tags.map((tag, idx) => (
                  <Chip
                    key={idx}
                    label={`${tag.key}: ${tag.value}`}
                    onDelete={() => handleDeleteTag(tag)}
                  />
                ))}
              </Box>
            </Box>
          )}
        </Box>
      )}

    <div className="buttons-addhour">
  {/* Cancel */}
  <Button
    onClick={handleCancel}
    disabled={actionClicked === "save" || cancelLoading}
  >
    <span className="adduser-button-content">
      {actionClicked === "cancel" && cancelLoading ? (
        <CircularProgress size={18} style={{ color: "red" }} />
      ) : (
        "Cancel"
      )}
    </span>
  </Button>

  {/* Save */}
  <Button
    variant="contained"
    onClick={handleSave}
    disabled={actionClicked === "cancel" || loading}
  >
    <span className="adduser-button-content">
      {actionClicked === "save" && loading ? (
        <CircularProgress size={18} style={{ color: "white" }} />
      ) : (
        "Save"
      )}
    </span>
  </Button>
</div>

    </Container>
 
  );
};

export default AddRoutingProfilePage;